import React, { useCallback,useState, useMemo } from "react";
import { Table, Row, Col } from "reactstrap";
import CreatorListsRow from "./creatorListsRow";
import CreatorListModal from "./modals/creatorListModal";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

const CreatorListsTable = (props) => {
  const { t } = useTranslation();
  const { creatorLists, deleteCreatorList } = props;

  const [creatorListView, setCreatorListView] = useState(false);
  const [selectedListId, setSelectedListId] = useState(null);

  const selectedCreatorList = useMemo(() => 
    creatorLists?.find(list => list?._id === selectedListId)
  , [creatorLists, selectedListId]);

  const toggleCreatorListView = useCallback((list_id) => {
    if (!creatorListView) {
      setSelectedListId(list_id);
    } else {
      setSelectedListId(null);
    }
    setCreatorListView(!creatorListView);
  }, [creatorListView]);

  const columns = ["name", "networks", "creators", "reach", "modified"];
  const columnHeaders = columns.map((column, index) => (
    <th key={index}>{t(`creator_lists.list_table.${column}_header`)}</th>
  ));

  const tableData = useMemo(() =>
    creatorLists?.map((list) => {
      return list ? (
        <CreatorListsRow
          key={list?._id}
          creatorList={list}
          toggleModal={toggleCreatorListView}
          deleteCreatorList={deleteCreatorList}
        ></CreatorListsRow>
      ) : null;
    })
    , [creatorLists, toggleCreatorListView, deleteCreatorList]);

  return (
    <Row className="search-results-wrap">
      <CreatorListModal
        isOpen={creatorListView}
        toggleModal={toggleCreatorListView}
        creatorList={selectedCreatorList}
        deleteCreatorList={deleteCreatorList}
        key={selectedCreatorList?._id}
      />
      <Col md="12">
        <div className="table-responsive table-outer user-profile-table creator-lists-table">
          <Table hover borderless>
            <thead>
              <tr>{columnHeaders}</tr>
            </thead>
            <tbody>
              {creatorLists?.length ? (
                tableData
              ) : (
                <tr>
                  <td colSpan={columns.length} align="center">
                    {t("errors.no_record")}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Col>
    </Row>
  );
};

const mapStateToProps = (state) => {
  return {
    creatorLists: state.creatorLists.lists,
  };
};
export default connect(mapStateToProps)(CreatorListsTable);
